export const STORAGE_KEY = {
  PAYMENT_HASH: 'paymentHash',
  SAVE_DATA: 'save',
  SAVE_CACHE: 'saveCache',
  UNITY_CACHE: 'unityCache',
  NEED_CLEAR_UNITY_CACHE: 'needClearUnityCache',
  PROMO_DATA: 'promoData_',
};

export const GAMES_ID = {
  LUCKY_VERSE: 1,
  KILL_THEM_ALL: 2,
  LUCKY_VERSE_TEST: 4,
};

export const ADS_ID = {
  ADSGRAM: 1,
  TADS: 2,
  TAPPADS: 3,
};

export const DEFAULT_USER = {
  id: 252,
  first_name: '123',
  last_name: '345',
  username: 'asdw',
  language_code: 'ru',
  allows_write_to_pm: true,
  is_premium: true,
  photo_url: 'hey.com',
};

export const GA4_KEY = {
  unity_update: {
    category: 'UPDATE_UNITY_APP',
    action: 'clear cache and download new version',
  },
  unity_initializate: {
    category: 'INITIAL_UNITY_APP',
    action: 'initializate app',
  },
  unity_added_script: {
    category: 'ADD_UNITY_SCRIPT',
    action: 'add a third-party script ',
  },
  unity_get_products: {
    category: 'GET_UNITY_PRODUCTS',
    action: 'GetProducts/OnProductsGet events from Unity',
  },
  unity_get_balance: {
    category: 'GET_UNITY_BALANCE',
    action: 'GetBalance/OnGetBalance event from Unity',
  },
  untity_share: {
    category: 'SHARE',
    action: 'share to telegram chat',
  },
  untity_share_story: {
    category: 'SHARE',
    action: 'share to telegram story',
  },
  unity_save_link_to_clipboard: {
    category: 'SAVE_LINK_TO_CLIPBOARD',
    action: 'save link to clipboard',
  },
  unity_get_leaderboard: {
    category: 'GET_LEADERBOARD',
    action: 'GetLeaderboardData/LoadLeaderboardData event from Unity',
  },
  unity_load_save: {
    category: 'LOAD_SAVE',
    action: 'LoadData/OnSavesLoad event from Unity',
  },
  unity_save_data: {
    category: 'SAVE_DATA',
    action: 'Save to unity and telegram storage',
  },
  unity_save_data_to_telegram_storage: {
    category: 'SAVE_UNITY_DATA',
    action: 'Save unity data to telegram storage',
  },
  unity_send_telegram_storage: {
    category: 'SEND_TELEGRAM_STORAGE_DATA',
    action: 'send data from telegram storage to unity',
  },
  payment: (productName, stars = false) => {
    return {
      category: `creted payment for ${stars ? 'stars' : 'ton'}`,
      action: `payment for ${productName}`,
    };
  },
  added_app_icon: {
    category: 'ADD_APP_ICON',
    action: 'add app icon for home screen',
  },
};

export const GAMES_CURRENCIES = {
  TON: {
    name: 'TON',
    symbol: (
      <svg
        width='41.6'
        height='41.6'
        viewBox='6.25 7.93 18.5 18.57'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M21.4631 8.93014H10.5363C8.52732 8.93014 7.25396 11.0972 8.26469 12.8492L15.0083 24.5377C15.4483 25.3009 16.5511 25.3009 16.9912 24.5377L23.7361 12.8492C24.7455 11.1001 23.4721 8.93014 21.4645 8.93014H21.4631ZM15.0028 21.0324L13.5341 18.1902L9.99039 11.852C9.75671 11.4465 10.0454 10.9267 10.535 10.9267H15.0013V21.0338L15.0028 21.0324ZM22.0061 11.8537L18.4639 18.1916L16.9952 21.0324V10.9253H21.4615C21.9512 10.9253 22.2399 11.4451 22.0061 11.8537Z'
          fill='white'
        />
      </svg>
    ),
    code: 'TON',
    className: 'ton',
  },
  Notcoin: {
    name: 'Notcoin',
    symbol: (
      <svg
        width='41.6'
        height='41.6'
        viewBox='-4 1 30 30'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g transform='scale(1,-1) translate(0,-34)'>
          <path
            d='M21.4631 8.93014H10.5363C8.52732 8.93014 7.25396 11.0972 8.26469 12.8492L15.0083 24.5377C15.4483 25.3009 16.5511 25.3009 16.9912 24.5377L23.7361 12.8492C24.7455 11.1001 23.4721 8.93014 21.4645 8.93014H21.4631ZM15.0028 21.0324L13.5341 18.1902L9.99039 11.852C9.75671 11.4465 10.0454 10.9267 10.535 10.9267H15.0013V21.0338L15.0028 21.0324ZM22.0061 11.8537L18.4639 18.1916L16.9952 21.0324V10.9253H21.4615C21.9512 10.9253 22.2399 11.4451 22.0061 11.8537Z'
            fill='white'
          />
        </g>
      </svg>
    ),
    code: 'Notcoin',
    className: 'ton',
  },
  'Hamster Kombat': {
    name: 'Hamster Kombat',
    symbol: null,
    code: 'Hamster Kombat',
    className: 'ton',
  },
  Catizen: {
    name: 'Catizen',
    symbol: null,
    code: 'Catizen',
    className: 'ton',
  },
  'Tether USDt': {
    name: 'Tether USDt',
    symbol: null,
    code: 'Tether USDt',
    className: 'ton',
  },
  STARS: {
    name: 'STARS',
    symbol: (
      <img
        id='stars'
        src='data:image/svg+xml,%3Csvg%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20width%3D%2220%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20xmlns%3Axlink%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxlink%22%3E%3Cdefs%3E%3Cpath%20id%3D%22a%22%20d%3D%22m6.02%204.99%202.21-4.42c.25-.51.86-.72%201.37-.46.2.1.36.27.46.47l2.08%204.26c.17.34.5.58.88.63l4.36.52c.59.08%201.02.62.95%201.22-.03.24-.14.47-.32.65l-3.45%203.42c-.14.13-.2.33-.18.53l.57%204.61c.09.66-.38%201.27-1.03%201.35-.25.03-.5-.02-.72-.14l-3.64-2c-.26-.14-.58-.15-.85-.01l-3.77%201.95c-.53.27-1.18.06-1.45-.48-.11-.2-.14-.43-.11-.65l.3-2.12c.15-1.04.79-1.93%201.71-2.41l4.19-2.15c.11-.06.15-.2.1-.31-.05-.09-.14-.14-.24-.12l-5.12.74c-.78.11-1.58-.11-2.19-.62l-1.71-1.4c-.49-.4-.56-1.12-.17-1.62.19-.22.45-.37.74-.41l4.38-.57c.28-.03.52-.21.65-.46z%22%2F%3E%3ClinearGradient%20id%3D%22b%22%20x1%3D%2225%25%22%20x2%3D%2274.92%25%22%20y1%3D%22.825%25%22%20y2%3D%22107.86%25%22%3E%3Cstop%20offset%3D%220%22%20stop-color%3D%22%23ffd951%22%2F%3E%3Cstop%20offset%3D%221%22%20stop-color%3D%22%23ffb222%22%2F%3E%3C%2FlinearGradient%3E%3ClinearGradient%20id%3D%22c%22%20x1%3D%2250%25%22%20x2%3D%2250%25%22%20y1%3D%220%25%22%20y2%3D%2299.8%25%22%3E%3Cstop%20offset%3D%220%22%20stop-color%3D%22%23e58f0d%22%2F%3E%3Cstop%20offset%3D%22.9996%22%20stop-color%3D%22%23eb7915%22%2F%3E%3C%2FlinearGradient%3E%3Cfilter%20id%3D%22d%22%20height%3D%22110.6%25%22%20width%3D%22110.3%25%22%20x%3D%22-5.2%25%22%20y%3D%22-5.3%25%22%3E%3CfeOffset%20dx%3D%221%22%20dy%3D%221%22%20in%3D%22SourceAlpha%22%20result%3D%22shadowOffsetInner1%22%2F%3E%3CfeComposite%20in%3D%22shadowOffsetInner1%22%20in2%3D%22SourceAlpha%22%20k2%3D%22-1%22%20k3%3D%221%22%20operator%3D%22arithmetic%22%20result%3D%22shadowInnerInner1%22%2F%3E%3CfeColorMatrix%20in%3D%22shadowInnerInner1%22%20type%3D%22matrix%22%20values%3D%220%200%200%200%201%200%200%200%200%201%200%200%200%200%201%200%200%200%200.657%200%22%2F%3E%3C%2Ffilter%3E%3C%2Fdefs%3E%3Cg%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%20transform%3D%22translate%281.389%201.389%29%22%3E%3Cuse%20fill%3D%22url%28%23b%29%22%20fill-rule%3D%22evenodd%22%20xlink%3Ahref%3D%22%23a%22%2F%3E%3Cuse%20fill%3D%22%23000%22%20filter%3D%22url%28%23d%29%22%20xlink%3Ahref%3D%22%23a%22%2F%3E%3Cuse%20stroke%3D%22url%28%23c%29%22%20stroke-width%3D%22.89%22%20xlink%3Ahref%3D%22%23a%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E'
        alt='STARS icon'
      />
    ),
    code: 'STARS',
    className: 'stars',
  },
  SOL: {
    name: 'Solana',
    symbol: (
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 398 312'>
        <defs>
          <linearGradient
            id='g1'
            x1='361'
            y1='-37'
            x2='141'
            y2='383'
            gradientUnits='userSpaceOnUse'
          >
            <stop offset='0' stop-color='#00FFA3' />
            <stop offset='1' stop-color='#DC1FFF' />
          </linearGradient>
          <linearGradient
            id='g2'
            x1='265'
            y1='-88'
            x2='45'
            y2='333'
            gradientUnits='userSpaceOnUse'
          >
            <stop offset='0' stop-color='#00FFA3' />
            <stop offset='1' stop-color='#DC1FFF' />
          </linearGradient>
          <linearGradient
            id='g3'
            x1='313'
            y1='-63'
            x2='93'
            y2='358'
            gradientUnits='userSpaceOnUse'
          >
            <stop offset='0' stop-color='#00FFA3' />
            <stop offset='1' stop-color='#DC1FFF' />
          </linearGradient>
        </defs>
        <path
          fill='url(#g1)'
          d='M65 238c2-2 6-4 9-4h317c6 0 9 7 5 11l-63 63c-2 2-6 4-9 4H7c-6 0-9-7-5-11l63-63z'
        />
        <path
          fill='url(#g2)'
          d='M65 4c2-2 6-4 9-4h317c6 0 9 7 5 11l-63 63c-2 2-6 4-9 4H7c-6 0-9-7-5-11L65 4z'
        />
        <path
          fill='url(#g3)'
          d='M333 120c-2-2-6-4-9-4H7c-6 0-9 7-5 11l63 63c2 2 6 4 9 4h317c6 0 9-7 5-11l-63-63z'
        />
      </svg>
    ),
    code: 'SOL',
    className: '',
  },
  TOKEN: {
    name: 'Token',
    symbol: null,
    code: 'TOKEN',
    className: '',
  },
};
